import { ModalEnum } from '@/interfaces'
import { useStores } from '@/stores/RootStoreContext'
import { Button, Flex } from 'antd'
import PropTypes from 'prop-types'

const Footer = (props) => {
  const { onConfirm, step, loading } = props

  const { modalStore } = useStores()

  const closeModal = () => {
    modalStore.closeModal(ModalEnum.CANCEL_PLAN)
  }

  const confirmLabel = {
    reason: 'Cancelar assinatura',
    password: 'Confirmar cancelamento',
  }[step]

  const secondaryLabel =
    {
      confirmation: 'OK, fechar',
    }[step] || 'Manter assinatura'

  return (
    <Flex justify={step === 'confirmation' ? 'center' : 'space-between'}>
      {confirmLabel && (
        <Button
          onClick={onConfirm}
          loading={loading}
          disabled={loading}
          color="primary"
          size="large"
          variant="outlined"
          shape="default"
          style={{ borderRadius: 6 }}
        >
          {confirmLabel}
        </Button>
      )}

      <Button
        onClick={closeModal}
        disabled={loading}
        type="primary"
        size="large"
        shape="default"
        style={{ borderRadius: 6 }}
      >
        {secondaryLabel}
      </Button>
    </Flex>
  )
}

Footer.propTypes = {
  step: PropTypes.oneOf(['reason', 'password', 'confirmation']).isRequired,
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool,
}

export default Footer
